import React from 'react';
import ProfileEditForm from '../components/ProfileEditForm';

const ProfileEditPage: React.FC = () => {
  return <ProfileEditForm />;
};

export default ProfileEditPage;
